import AsyncButton from "@/components/AsyncButton";
import { useFormButtonStateDisabled } from "@/hooks/useFormButtonStateDisabled";
import { useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface SubmitButtonProps {
  className?: string;
  labelClassName?: string;
  label?: string;
  loadingLabel?: string;
  isLoading?: boolean;
  icon?: React.ReactNode | null;
  disabled?: boolean;
}

export default function SubmitButton(props: SubmitButtonProps) {
  const {
    className,
    labelClassName,
    label,
    loadingLabel,
    icon,
    disabled: disabledFromProps,
    isLoading: isLoadingFromProps = false,
  } = props;
  const { t } = useTranslation();
  const { isSubmitting } = useFormState();
  const disabled = useFormButtonStateDisabled(disabledFromProps);

  return (
    <AsyncButton
      type="submit"
      disabled={disabled}
      className={className}
      loadingLabel={loadingLabel || t("commonEditor.toolbar.saving")}
      label={label || t("commonEditor.toolbar.save")}
      labelClassName={labelClassName}
      loading={isSubmitting || isLoadingFromProps}
      icon={icon === null ? undefined : icon}
    />
  );
}
